import { t } from '../../../strings/i18n';
import { required } from '../../../xform';
export const FULLNAME_INPUT_NAME = 'fullName';
const fullNameConfig = () => [
    FULLNAME_INPUT_NAME,
    undefined,
    'ENABLED',
    [required(t('errors.fullNameRequired'))]
];
export default fullNameConfig;
